import { render, staticRenderFns } from "./ApexDonutChart.vue?vue&type=template&id=52fb9334"
import script from "./ApexDonutChart.vue?vue&type=script&lang=js"
export * from "./ApexDonutChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports